
import { Component, Ref } from 'vue-property-decorator';
import Page from '@/Page.vue';
import moment from 'moment';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { PlanItemModel } from '@/libs/Api';

@Component({})
export default class WorkTaskEditShutdownTime extends Page {
    protected dialog = false;
    protected id = '';
    protected title = '';
    protected property = '';
    protected saving = false;
    protected isValid = false;
    protected shutdownDate: string | null | undefined = null;
    protected minDate: string | null | undefined = null;
    protected maxDate: string | null | undefined = null;
    @Ref() form!: any;

    public open(
        id: string,
        title: string,
        property: string,
        initialValue: string | null | undefined,
        minDate: string | null | undefined,
        maxDate: string | null | undefined
    ): void {
        this.id = id;
        this.title = title;
        this.property = property;
        this.shutdownDate = initialValue;
        this.dialog = true;
        this.minDate = minDate;
        this.maxDate = maxDate;
    }

    public get isShutdownInFuture(): boolean {
        if (!this.shutdownDate) {
            return false;
        }
        return new Date(this.shutdownDate).getTime() > Date.now();
    }

    protected onSaveShutdownClick() {
        if (this.form.validate()) {
            this.saving = true;
            planItemsStore.dispatch(CrudAction.Get, { id: this.id, key: 'EditShutdown' });
            this.subscribe(planItemsStore, CrudReponse.Get, 'EditShutdown').then((item: any) => {
                const key = this.property as keyof PlanItemModel;
                item[key] = this.shutdownDate as any;
                planItemsStore.dispatch(CrudAction.Update, { item, key: 'EditShutdown' });
                this.subscribe(planItemsStore, CrudReponse.Update, 'EditShutdown').then(() => {
                    this.saving = false;
                    this.dialog = false;
                    this.$emit('planItemChanged');
                });
            });
        }
    }

    protected onShutdownDateAddMinutes(minutes: number) {
        if (!this.shutdownDate) {
            this.shutdownDate = moment().format('YYYY-MM-DDTHH:mm:ss');
        }
        this.shutdownDate = moment(this.shutdownDate, 'YYYY-MM-DDTHH:mm:ss')
            .add(minutes, 'minutes')
            .format('YYYY-MM-DDTHH:mm:ss');
    }

    protected couldBeDateAddMinutesInFuture(minutes: number) {
        if (!this.shutdownDate) {
            return true;
        }
        return new Date(this.shutdownDate).getTime() + minutes * 60 * 1000 > new Date().getTime();
    }
}
